import PropTypes from 'prop-types'
import React from 'react'
import ReversibleArrow from '../ReversibleArrow'

import './RetractablePanel.less'

const classNames = require('classnames')

class RetractablePanel extends React.Component {
  constructor (props) {
    super(props)
    this.onArrowClick = this.onArrowClick.bind(this)
    this.isControlled = this.isControlled.bind(this)
    this.isShown = this.isShown.bind(this)
    this.state = {
      shown: true
    }
  }

  onArrowClick () {
    this.setState({shown: !this.state.shown})
    if (this.isShown()) {
      if (this.props.hide) {
        this.props.hide()
      }
    } else {
      if (this.props.show) {
        this.props.show()
      }
    }
  }

  isShown () {
    return this.isControlled() ? this.props.shown : this.state.shown
  }

  isControlled () {
    return (typeof this.props.shown === 'boolean' && (!!this.props.hide || !!this.props.show))
  }

  render () {
    let leftSideClasses = classNames({
      'nmc-retractable-panel': true,
      'nmc-retractable-panel-minified': !this.isShown()
    })

    return (
      <div className={leftSideClasses}>
        {this.props.children}
        <ReversibleArrow onClick={this.onArrowClick}
          reveresedArrow={!this.isShown()}
        />
      </div>
    )
  }
}

RetractablePanel.propTypes = {
  onArrowClick: PropTypes.func,
  hide: PropTypes.func,
  show: PropTypes.func,
  shown: PropTypes.bool
}

RetractablePanel.defaultProps = {
  shown: true
}

export default RetractablePanel



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/RetractablePanel/index.js